// extracted by mini-css-extract-plugin
export default {"container":"UpButton_container__rnOen","button":"UpButton_button__GkC-E","rotateIn":"UpButton_rotateIn__YHAmY"};